import { Tooltip, Icon, Intent } from '@blueprintjs/core'
import React from 'react'

interface GutterTooltipErrorProps {
  isOpen: boolean
  offsetPx: number // calculate this by hand, so that it appears in the page gutter
  position: any
  children
}

export const GutterTooltipError = ({ isOpen, offsetPx, position, children }: GutterTooltipErrorProps) => {
  // blueprint hasn't defined the fill prop as part of their API, but they're passing this into Popover.
  // We need this so that the children can still fill 100% of their width
  const tsIgnoreParams = { fill: true }

  if (!offsetPx) {
    return children
  }

  return (
    <Tooltip
      popoverClassName="gutter-tooltip-error"
      className="stretch-full stretch-12" /* Regarding stretch-full, this ensures DescriptionEditor is still full width. Regarding stretch-12, see "Create another 12 column grid". */
      content={<Icon icon="issue" size={20} />}
      position={position}
      intent={Intent.DANGER}
      isOpen={!!(isOpen && offsetPx)}
      modifiers={{
        offset: { options: { offset: [0, offsetPx] } },
        flip: {
          enabled: false /* keep the tooltip in the specified position even if the browser doesn't have enough room */
        }
      }}
      {...tsIgnoreParams}
      openOnTargetFocus={false}
    >
      {children}
    </Tooltip>
  )
}
